import { Collapse, Flex } from '@mantine/core';

import { BannerType } from 'models';

import { useBannerMessage } from 'hooks/use-banner-message';

import cx from './HeaderBannerMessage.module.scss';

const HeaderBannerMessage = () => {
    const { BannerContent, showBanner } = useBannerMessage(BannerType.Header);

    return (
        <Collapse expanded={showBanner}>
            <Flex
                p="sm"
                justify="space-between"
                bdrs="md"
                className={`${cx['header-banner']} gradient-cyan-green-background-light`}
            >
                {BannerContent}
            </Flex>
        </Collapse>
    );
};

export { HeaderBannerMessage };
